import { render, staticRenderFns } from "./AdminHome.vue?vue&type=template&id=31d50e20&"
import script from "./AdminHome.vue?vue&type=script&lang=ts&"
export * from "./AdminHome.vue?vue&type=script&lang=ts&"
import style0 from "./AdminHome.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports